export enum SendTokenStatus {
  Active = 'active',
  Trialing = 'trialing',
  Incomplete = 'incomplete',
}
